<template>
  <addService :service="service" :loading="loading" />
</template>
<script>
import addService from '@/pages/service/add'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { currency } from '@/mixins/currency'
import { getAServiceVisit } from '@/api/services'

export default {
  mixins: [gregorianToJalali, currency],
  data() {
    return {
      service: null,
      loading: true,
    }
  },
  components: {
    addService,
  },
  created() {
    getAServiceVisit.api(this.$route.params.id).then((res) => {
      if (!res) {
        this.loading = false
        return
      }

      this.service = {
        id: res.id,
        visit: true,
        identifier: res.identifier || '',
        date: this.gregorianToJalali(res.date),
        description: res.description || '',
        odometer:
          res.odometer !== 0 && res.odometer
            ? this.currency(res.odometer / 1000)
            : 0,
        total_price: res.total_price ? this.currency(res.total_price) : '',
        company_vehicle: res.company_vehicle?.id || res.company_vehicle,
        disabled: this.$route.name.includes('VIEW'),
        attachments: res.attachments || [],
        items: (res.items || []).map((item) => ({
          id: item.id,
          service: item.service?.id || item.service,
          price: this.currency(item.price),
          meter_interval:
            item.meter_interval !== 0 && item.meter_interval
              ? item.meter_interval / 1000
              : null,
          meter_threshold:
            item.meter_threshold !== 0 && item.meter_threshold
              ? item.meter_threshold / 1000
              : null,
          day_interval: item.day_interval,
          day_threshold: item.day_threshold,
        })),
      }
      this.loading = false
    })
  },
}
</script>
